import { DateDirection, DelayType, ViewFilterNumberComparison } from 'types/graphql'

export const DateFilterDirectionNamesByDirection: Record<DateDirection, string> = {
  Future: 'Next',
  Past: 'Previous',
}

export const getLabelForDateFilterDelayType = (delayType: DelayType, isPlural: boolean) => {
  switch (delayType) {
    case 'Day':
      return isPlural ? 'Days' : 'Day'
    case 'Week':
      return isPlural ? 'Weeks' : 'Week'
    case 'Month':
      return isPlural ? 'Months' : 'Month'
    case 'Year':
      return isPlural ? 'Years' : 'Year'
  }
  return ''
}

export const TABLE_VIEW_HEADER_BREAKPOINT_PX = 768

export const NumberFilterComparisonOptions: ViewFilterNumberComparison[] = [
  'Equals',
  'GreaterThan',
  'GreaterThanOrEqualTo',
  'LessThan',
  'LessThanOrEqualTo',
]

export const getLabelForNumberFilterComparison = (
  comparison: ViewFilterNumberComparison
): string => {
  switch (comparison) {
    case 'Equals':
      return 'Equals'
    case 'GreaterThan':
      return 'Greater than'
    case 'GreaterThanOrEqualTo':
      return 'Greater than or equal to'
    case 'LessThan':
      return 'Less than'
    case 'LessThanOrEqualTo':
      return 'Less than or equal to'
    default:
      return ''
  }
}

export const getAbbreviationForNumberFilterComparison = (
  comparison: ViewFilterNumberComparison
): string => {
  switch (comparison) {
    case 'Equals':
      return '='
    case 'GreaterThan':
      return '>'
    case 'GreaterThanOrEqualTo':
      return '>='
    case 'LessThan':
      return '<'
    case 'LessThanOrEqualTo':
      return '<='
    default:
      return ''
  }
}
